import { IS_PRODUCTION, TCHOP_ROOT_URL } from '../../env';
import { getOrganisationDomain } from './getOrganisationDomain';

export const getOrganisationUrl = () => {
  if (!IS_PRODUCTION) {
    return '/organisation/api';
  }

  const organisation = getOrganisationDomain();

  const { host, protocol } = new URL(TCHOP_ROOT_URL);

  return `${protocol}//${organisation}.${host}/api`;
};
